import React from 'react';
import PropTypes from 'prop-types';
import RenderTextInputField from 'components/form/InputFields/RenderTextInputField';
import SubmitButton from 'components/button/SubmitButton';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import validations from 'helpers/forms/validations';
import { ButtonWrapper, FormWrapper, Item, Row, Section } from 'components/ui/table/elements';
import { Field, reduxForm } from 'redux-form';

const MembershipPoolCreateForm = (props) => {
    const {
        handleSubmit,
        handleSubmitForm,
        submitting,
        translate,
    } = props;

    const onSubmit = (data) => {
        handleSubmitForm(data);
    };

    return (
        <FormWrapper>
            <form onSubmit={ handleSubmit(onSubmit) }>
                <Section>
                    <Row>
                        <Item>
                            <Field
                                component={ RenderTextInputField }
                                fullWidth={ false }
                                label={ translate('filters.components.name.label') }
                                name='name'
                                validate={ validations.required }
                            />
                        </Item>
                    </Row>

                    <Row>
                        <Item>
                            <Field
                                component={ RenderTextInputField }
                                fullWidth={ false }
                                label={ translate('fields.size') }
                                name='size'
                                validate={ [
                                    validations.required,
                                    validations.number,
                                ] }
                            />
                        </Item>
                    </Row>
                </Section>

                <Section>
                    <Row>
                        <ButtonWrapper>
                            <SubmitButton loading={ submitting } />
                        </ButtonWrapper>
                    </Row>
                </Section>
            </form>
        </FormWrapper>
    );
};

MembershipPoolCreateForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    handleSubmitForm: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    translate: PropTypes.func.isRequired,
};

const enhance = compose(
    translate,
    reduxForm(),
);

export default enhance(MembershipPoolCreateForm);


// WEBPACK FOOTER //
// ./src/pages/membership-pools/create/MembershipPoolCreateForm.js